export const reloadPage = (): void => {
  const redirectUrl = getUrlFromParam(window.location.search, "callback_url");
  if (redirectUrl) {
    window.location.href = redirectUrl;
  } else {
    window.location.reload();
  }
};

export const getUrlFromParam = (url: string, name: string): string | null => {
  const urlPart = url.substr(1);
  if (urlPart === "") {
    return null;
  }

  const args: string[] = urlPart.split("&");
  const params: { [key: string]: string } = {};
  for (const arg of args) {
    const param: string[] = arg.split("=");
    params[param[0]] = param[1];
  }

  return sanitizeEncodedUrl(params[name]) || null;
};

const sanitizeEncodedUrl = (param: string): string | null => {
  const regex = /^(%2F[\w-#/]*)+/g;
  const match = (param || "").match(regex);
  if (match && match[0]) {
    return decodeURIComponent(match[0]);
  } else {
    return null;
  }
};
